// extracted by mini-css-extract-plugin
module.exports = {"show_notes_wrapper":"_2sAlS","show_notes":"KhY3f"};